import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './Navbar';
import MortgageCalculator from './MortgageCalculator';
import RefinanceCalculator from './mortgage/RefinanceCalculator';
import PaymentEstimator from './mortgage/PaymentEstimator';
import AffordabilityCalculator from './mortgage/AffordabilityCalculator';
import SavingsCalculator from './savings/SavingsCalculator';
import { ThemeProvider } from '../context/ThemeContext';
import { CurrencyProvider } from '../context/CurrencyContext';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <CurrencyProvider>
        <Router>
          <div className="app">
            <Navbar />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<MortgageCalculator />} />
                <Route path="/mortgage" element={<MortgageCalculator />} />
                <Route path="/mortgage/refinance" element={<RefinanceCalculator />} />
                <Route path="/mortgage/payment" element={<PaymentEstimator />} />
                <Route path="/mortgage/affordability" element={<AffordabilityCalculator />} />
                <Route path="/savings" element={<SavingsCalculator />} />
              </Routes>
            </main>
          </div>
        </Router>
      </CurrencyProvider>
    </ThemeProvider>
  );
}

export default App;
